import Button from "src/components/Button";
import { ReactComponent as PC } from "src/assets/svg/pc2.svg";
import { useAppSelector } from "src/redux/store";

const ATS = ({ unlink, unlinking }: { unlink: () => void; unlinking: boolean }) => {
  const ats = useAppSelector((r) => r.client.client?.Company.Ats);
  if (!ats) return null;
  return (
    <div className="w-full h-full flex ">
      <div className="w-[500px] bg-white rounded-2xl px-6 py-9 flex flex-col items-center justify-center text-center gap-6 mx-auto my-auto">
        <p className="font-poppins text-xl font-semibold">Disconnect {ats.integration}</p>
        <PC className="w-[210px]" />
        <p className="font-poppins text-base leading-8 text-center">
          Are you sure you want to disconnect {ats.integration} ATS? All associated data will be
          permanently deleted.
        </p>
        <Button loading={unlinking} onClick={unlink} variant="red" shapeVariant={2}>
          Disconnect Now
        </Button>
      </div>
    </div>
  );
};

export default ATS;
